export default {
  data: () => ({
    procesandoPago: false,
  }),

  methods: {
    async ejecutarProcesoPago( proceso ) {
      this.procesandoPago = true
      try {
        return await proceso()
      } finally {
        this.procesandoPago = false
      }
    },
  },
}
